// extracted by mini-css-extract-plugin
module.exports = {"InfluencerDesk":"_2VYUF-im","column":"_26x5HBPc","name":"_2chLWOk9","header":"_28E_pmW2","large":"_2w-PQs4E"};